import { useRefreshPasswordMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import { SignInSignUpLayout, RefreshPasswordForm, RefreshPasswordFormValues } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const PasswordForgot = () => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callRefreshPassword } = useRefreshPasswordMutation();

  const handleSubmit: FormAction<RefreshPasswordFormValues>['onSubmit'] = async ({ email }, methods) => {
    try {
      const result = await callRefreshPassword({ variables: { input: { email } } });

      if (result?.data?.refreshPassword) {
        methods.setValue('isSuccess', true);
      } else {
        enqueueSnackbar(t(UNEXPECTED_ERROR), { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar(t('failedToRequest'), { variant: 'error' });
      enqueueSnackbar(t(error?.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <SignInSignUpLayout css={{ paddingTop: '82px', justifyContent: 'flex-start' }}>
      <RefreshPasswordForm onSubmit={handleSubmit} />
    </SignInSignUpLayout>
  );
};
